import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React, { FC } from 'react'
import { USStates } from '../../../common/helpers'
import { Flex, USPhoneInput } from '../../../components/common/Helpers'

type TextfieldProps = {
    value: string,
    onChange(event: React.ChangeEvent<{ value: unknown }>): void
}

interface IProps {
    title: string

    statusList: string[]
    firstName: TextfieldProps
    lastName: TextfieldProps
    email: TextfieldProps
    status: {
        value: string,
        onChange(value: string): void
    }
    phone: {
        value: string,
        onChange(value: string): void
    }
    zip: TextfieldProps
    address1: TextfieldProps
    address2: TextfieldProps
    city: TextfieldProps
    province: {
        value: string
        onChange(v: string): void
    }
    country: TextfieldProps
    note: TextfieldProps

    button: {
        text: string,
        onClick(): void
    }

    needSave?: boolean
    // editable: boolean
    onDialogClose(): void

}

const CostumerUIBox: FC<IProps> = props => {

    return (
        <Dialog open onClose={props.onDialogClose}>
            <DialogTitle>{props.title}</DialogTitle>
            {/* <Divider /> */}
            <DialogContent dividers>

                <Box
                    display='flex'
                    flexDirection='column'
                    alignItems='center'
                    pb={2}
                    style={{
                        width: 400,
                        height: 'fit-content',
                        // margin: 15,
                        // border: '1px solid black',
                        maxHeight: '90%',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        position: 'relative'
                    }}
                >

                    {/* <Box
                        py={1}
                        style={{
                            position: 'sticky',
                            top: 0,
                            width: '100%',
                            backgroundColor: 'white',
                            zIndex: 10
                        }}>
                        <Grid container spacing={2}>
                            <Grid item xs={3}> </Grid>
                            <Grid item xs={6} container justifyContent='center' alignItems='center'>
                                <Typography variant='h6'>{props.title}</Typography>
                            </Grid>
                            <Grid item xs={3} container justifyContent='flex-end' alignItems='center'>
                                <Tooltip title={props.title === 'New Costumer' ? 'Create' : 'Save'}>
                                    <Fab
                                        color={props.needSave ? 'secondary' : "primary"}
                                        size='small'
                                        onClick={props.button.onClick}
                                        style={{ marginRight: 10 }}
                                    >
                                        {props.title === 'New Costumer' ? <NoteAddIcon /> : <SaveIcon />}
                                    </Fab>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box> */}


                    <Flex column sx={{ px: 4, pt: 2, gap: 2 }}>

                        <Flex sx={{ gap: 1 }}>
                            <TextField
                                label="First Name"
                                variant="outlined"
                                value={props.firstName.value}
                                onChange={props.firstName.onChange}
                                required
                            />
                            <TextField
                                label="Last Name"
                                variant="outlined"
                                value={props.lastName.value}
                                onChange={props.lastName.onChange}
                                required
                            />
                        </Flex>
                        <TextField
                            label="Email"
                            variant="outlined"
                            value={props.email.value}
                            onChange={props.email.onChange}
                            sx={{ width: 1 }}
                            required
                        />

                        <FormControl fullWidth>
                            <InputLabel>Status</InputLabel>
                            <Select
                                value={props.status.value || ''}
                                label="Status"
                                onChange={e => { props.status.onChange(e.target.value as string) }}
                            >
                                <MenuItem value={''}></MenuItem>
                                {
                                    props.statusList.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                        {/* 
                        <TextField
                            label="Phone"
                            variant="outlined"
                            value={props.phone.value}
                            onChange={props.phone.onChange}
                            type='number'
                            sx={{ width: 1 }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">+1</InputAdornment>,
                            }}
                        /> */}
                        <USPhoneInput
                            value={props.phone.value}
                            onChange={props.phone.onChange}
                        />


                        <TextField
                            label="Address 1"
                            variant="outlined"
                            value={props.address1.value}
                            onChange={props.address1.onChange}
                            sx={{ width: 1 }}
                        />

                        <TextField
                            label="Address 2"
                            variant="outlined"
                            value={props.address2.value}
                            onChange={props.address2.onChange}
                            sx={{ width: 1 }}
                        />

                        <TextField
                            label="City"
                            variant="outlined"
                            value={props.city.value}
                            onChange={props.city.onChange}
                            sx={{ width: 1 }}
                        />

                        <Flex sx={{ gap: 1 }}>
                            <Autocomplete
                                sx={{ width: .6 }}
                                options={USStates}
                                autoHighlight
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => <TextField {...params} label='State' />}
                                value={USStates.find(s => s.name === props.province.value)}
                                onChange={(e, newValue) => {
                                    props.province.onChange(newValue?.name || '')
                                }}
                            />
                            <TextField
                                label="Zip Code"
                                variant="outlined"
                                value={props.zip.value}
                                onChange={props.zip.onChange}
                                type='number'
                                sx={{ width: .4 }}
                            />
                        </Flex>

                        <TextField
                            label="Country"
                            variant="outlined"
                            value={props.country.value}
                            onChange={props.country.onChange}
                            disabled
                            sx={{ width: 1 }}
                        />

                        <TextField
                            label="Note"
                            variant="outlined"
                            value={props.note.value}
                            onChange={props.note.onChange}
                            sx={{ width: 1 }}
                            multiline
                        />
                    </Flex>


                    {/* <TextField
                label="Markup Value"
                variant="outlined"
                type='number'
                value={props.value.value}
                onChange={props.value.onChange}
                style={{ width: '60%', marginTop: 15 }} 
            /> */}

                </Box >
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    color={props.needSave ? 'secondary' : "primary"}
                    onClick={props.button.onClick}

                >{props.title === 'New Costumer' ? 'Create' : 'Save'}</Button>
                {/* <Tooltip title={props.title === 'New Costumer' ? 'Create' : 'Save'}>
                                    <Fab
                                        color={props.needSave ? 'secondary' : "primary"}
                                        size='small'
                                        onClick={props.button.onClick}
                                        style={{ marginRight: 10 }}
                                    >
                                        {props.title === 'New Costumer' ? <NoteAddIcon /> : <SaveIcon />}
                                    </Fab>
                                </Tooltip> */}
            </DialogActions>
        </Dialog>

    )
}

export default CostumerUIBox